import URL from '@/api/URL';
import fetch from '@/api/fetch';

export function getCensusBusiness (params) {
  return fetch.post(URL.getCensusBusiness, params);
}

export function setCensusBusiness (params) {
  return fetch.post(URL.setCensusBusiness, params);
}

export function getCensusUser (params) {
  return fetch.post(URL.getCensusUser, params);
}

export function setCensusUser (params) {
  return fetch.post(URL.setCensusUser, params);
}

export function businessStatistics (params) {
  return fetch.post(URL.businessStatistics, params);
}
export function querySurvival (params) {
  return fetch.post(URL.querySurvival, params);
}




// WEBPACK FOOTER //
// ./src/api/modules/statistics.js